import { Component, OnDestroy, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { HttpService } from 'app/services/http.service';
import { v4 as uuid } from 'uuid';

type PredictionObject = {
  description: string;
  matched_substrings: { length: number, offset: number }[],
  place_id: string,
  reference: string,
  structured_formatting: {
    main_text: string,
    main_text_matched_substrings: { length: number, offset: number }[],
    secondary_text: string
  },
  terms: { offset: number, value: string }[],
  types: string[]
}

export type AddressObject = {
  street: string;
  city?: string;
  state?: string;
  zip?: string;
  country?: string;
}

@Component({
  selector: 'app-address-input',
  templateUrl: './address-input.component.html',
  styleUrls: ['./address-input.component.scss'],
})
export class AddressInput implements OnInit, OnDestroy {
  @Input() for: string;
  @Output() addressSelected = new EventEmitter<AddressObject>();

  private parent: HTMLElement;
  private inputElm: HTMLInputElement;
  private sessionToken = uuid();
  predictions: PredictionObject[] = [];

  get parentWidth() {
    if (!this.inputElm?.clientWidth) return 'min-content';
    return `${this.inputElm.clientWidth - 5}px`;
  }

  constructor(
    private http: HttpService
  ) { }

  ngOnInit() {
    this.parent = document.getElementById('addr-ac-opts').parentElement;
    if (this.parent) this.parent.setAttribute('hidden', '');

    this.inputElm = document.getElementById(this.for) as HTMLInputElement;
    if (this.inputElm) this.inputElm.addEventListener('keyup', this.searchAutoComplete.bind(this));

    document.body.addEventListener('click', this.bodyClick.bind(this));
  }

  ngOnDestroy() {
    this.inputElm.removeEventListener('keyup', this.searchAutoComplete.bind(this));
    document.body.removeEventListener('click', this.bodyClick.bind(this));
  }

  private bodyClick(event) {
    if (this.parent.hasAttribute('hidden')) return;

    let rect = this.parent.getBoundingClientRect()
    let x = event.clientX, y = event.clientY;
    if (x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom) return;

    event.preventDefault();
    this.parent.setAttribute('hidden', '');
    return false;
  }

  private async searchAutoComplete(event) {
    let res = await this.http.addressAutoComplete(event.target.value, this.sessionToken);
    if (!res?.predictions?.length) {
      this.parent.setAttribute('hidden', '');
      this.predictions = [];
    } else {
      this.parent.removeAttribute('hidden');
      this.predictions = res.predictions;
    }
  }

  async selectAddr(address) {
    let addr: AddressObject = {
      street: address.structured_formatting.main_text
    };

    let details = await this.http.addressDetails(address.place_id, this.sessionToken);
    if (!details) return;

    ['locality', 'administrative_area_level_1', 'country', 'postal_code'].map((i) => {
      let d = details.result.address_components.find(a => a.types.includes(i));
      switch (i) {
        case 'locality': addr.city = d.short_name; break;
        case 'administrative_area_level_1': addr.state = d.short_name; break;
        case 'country': addr.country = d.short_name; break;
        case 'postal_code': addr.zip = d.short_name; break;
      }
    });

    this.addressSelected.emit(addr as any);
    this.parent.setAttribute('hidden', '');
  }
}
